import { IconName } from '@sbv-clients/ui-shared';

export const LabelToIconMapper: Record<string, IconName> = {
  Dashboard: 'DashboardOutlined',
  Dashboards: 'DashboardOutlined',
  Employee: 'EmployeesSVG',
  'Employee Center': 'EmployeesSVG',
  Reports: 'Documents',
  Schedule: 'SchedulingSVG',
  Scheduling: 'SchedulingSVG',
  'Setup / Configuration': 'SettingsSVG',
  Payroll: 'Payroll',
  'Global Users': 'EmployeesSVG',
  Databases: 'Database',
  'Base Facility Menu': 'List',
  'Database Stats': 'Stats',
  'Impersonation Logs': 'Logs',
  Tools: 'Tools',
  'Web Punch': 'Clock',
};
